/**
 * Route for `os-breakdown-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { OsBreakdownWidgetPage } from "../features/os-breakdown-widget/OsBreakdownWidgetPage";

export const osBreakdownWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/os-breakdown-widget",
	component: OsBreakdownWidgetPage,
});

export default osBreakdownWidgetRoute;
